(function () {
  "use strict";

  const pages = {
    "church-banners-flags": { name: "Church displays", url: "/pages/church-banners-flags" },
    "church-pole-banners": { name: "Church pole banners", url: "/pages/church-pole-banners" },
    "church-welcome-flags": { name: "Church welcome flags", url: "/pages/church-welcome-flags" },
    "church-backdrops": { name: "Church backdrops", url: "/pages/church-backdrops" },
    "church-tents": { name: "Church tents", url: "/pages/church-tents" }
  };
  const page = pages[document.body.dataset.page];
  if (!page) return;

  const origin = "https://mvpvisuals.com";
  const breadcrumbs = [
    { "@type": "ListItem", position: 1, name: "MVP Visuals", item: `${origin}/` }
  ];
  if (document.body.dataset.page !== "church-banners-flags") {
    breadcrumbs.push({ "@type": "ListItem", position: 2, name: "Church displays", item: `${origin}/pages/church-banners-flags` });
  }
  breadcrumbs.push({ "@type": "ListItem", position: breadcrumbs.length + 1, name: page.name, item: `${origin}${page.url}` });

  const faqs = [...document.querySelectorAll("details.faq")].map((faq) => ({
    "@type": "Question",
    name: faq.querySelector("summary").textContent.trim(),
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.querySelector(".faq__answer").textContent.trim().replace(/\s+/g, " ")
    }
  }));

  const graph = [
    { "@type": "BreadcrumbList", "@id": `${origin}${page.url}#breadcrumb`, itemListElement: breadcrumbs }
  ];
  if (faqs.length) graph.push({ "@type": "FAQPage", "@id": `${origin}${page.url}#faq`, mainEntity: faqs });

  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.dataset.churchStructuredData = "true";
  script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
  document.head.append(script);
})();
